import React from 'react';
import SvgIcon from '../../svgIcon/SvgIcon';

export function Loader(props) {
    return (
        <SvgIcon {...props}>
            <path id="logo" fill="none" stroke="#EDA820" strokeMiterlimit="10" d="M57.414 24.66C53 19.237 46.818 13.983 38.742 9.24l-.04-.014C30.57 4.596 22.923 1.882 16.028.77 11.73.075 9.67.88 8.723 1.413c-.928.546-2.666 1.92-4.21 6C2.024 13.955.57 21.922.5 31.288v.04c.068 9.374 1.523 17.348 4.014 23.87 1.543 4.083 3.28 5.46 4.21 6.002.946.54 3.007 1.347 7.304.658 6.895-1.123 14.54-3.838 22.676-8.472l.04-.02c8.074-4.74 14.256-9.994 18.67-15.405 2.744-3.383 3.086-5.57 3.086-6.654 0-1.074-.342-3.262-3.086-6.645z" />
            <circle id="circle" r="10" cx="0" cy="0" fill="#FFFFFF" />
            <animateMotion
                xlinkHref="#circle"
                dur="1s"
                begin="0s"
                repeatCount="indefinite"
                keyPoints="1;0"
                keyTimes="0;1"
                calcMode="linear"
                fill="#FFFFFF"
            >
                <mpath xlinkHref="#logo" />
            </animateMotion>>
        </SvgIcon>
    );
}

Loader.defaultProps = {
    viewBox: '0 0 61 62.624'
};

export default Loader;
